import { InitialFiltersMarketPremiumTypes } from '../Type';
import { InitialFiltersMarketPremiumState } from '../../reducers/initial-filter-market-premium/InitialFilterMarketPremiumReducer';

export const updateInitialFiltersMarketPremium = (payload: InitialFiltersMarketPremiumState) => {
  return (dispatch: any) => {
    dispatch({
      type: InitialFiltersMarketPremiumTypes.InitialFiltersMarketPremiumUpdate,
      payload,
    });
  };
};
